import PhaseCalculation from "./phaseCalculationUtil";
export default class EstimateCalculationUtil {
  constructor(estimates, calculations = []) {
    this.estimates = estimates || {};
    this.estimates.definedhourlyRate =
      this.estimates.billableSwitch && this.estimates.definedhourlyRate
        ? this.estimates.definedhourlyRate
        : null;
    this.calculations = calculations;
    this.totalEstimatePrice = this.totalEstimatePrice.bind(this);
    this.totalEstimateHours = this.totalEstimateHours.bind(this);
    this.totalEstimateCost = this.totalEstimateCost.bind(this);
    this.totalEstimateProfit = this.totalEstimateProfit.bind(this);
    this.totalEstimateProfitPercentage =
      this.totalEstimateProfitPercentage.bind(this);
    this.getDiscountValue = this.getDiscountValue.bind(this);
  }
  getDiscountValue() {
    const { discountType } = this.estimates;
    let { discountValue = 0 } = this.estimates;
    if (!discountValue || discountValue === "" || discountValue === "0") {
      return 0;
    }
    if (discountValue === 0) {
      return 0;
    }
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (typeof discountValue !== "number") {
      if (specialChars.test(discountValue)) {
        discountValue = discountValue.replace(/[^a-zA-Z0-9]/g, "");
      }
      discountValue = parseFloat(discountValue);
    }
    if (discountType === "%") {
      const temp = (this.totalEstimatePrice() * discountValue) / 100;
      return Math.round(temp);
    }
    return discountValue;
  }
  totalEstimatePrice() {
    const { phases = [] } = this.estimates;
    let total = 0;
    for (const phase of phases) {
      const phaseCalculation = new PhaseCalculation(
        phase,
        this.calculations,
        this.estimates
      );
      total += phaseCalculation.totalPhasePrice();
    }
    return total;
  }
  totalEstimateHours() {
    const { phases = [] } = this.estimates;

    let total = 0;
    for (const phase of phases) {
      const phaseCalculation = new PhaseCalculation(
        phase,
        this.calculations,
        this.estimates
      );
      total += phaseCalculation.totalPhaseHours();
    }
    return total;
  }
  totalEstimateCost() {
    const { phases = [] } = this.estimates;
    let total = 0;
    for (const phase of phases) {
      const phaseCalculation = new PhaseCalculation(
        phase,
        this.calculations,
        this.estimates
      );
      total += phaseCalculation.totalPhaseCost();
    }
    return isNaN(total) ? 0 : total;
  }
  totalEstimateProfit() {
    const profit = (
      this.totalEstimatePrice() -
      this.totalEstimateCost() -
      this.getDiscountValue()
    );
    return isNaN(profit) ? 0 : profit;
  }
  totalEstimateProfitPercentage() {
    const profit = this.totalEstimateProfit();
    const cost = this.totalEstimateCost();
    if (!cost) {
      return 0;
    }
    const result = Math.round((profit / cost) * 100);
    return isNaN(result) ? 0 : result;
  }
}
